import React, {useRef} from 'react';
import {Dropdown, DropdownButton, Spinner, Badge, Tooltip, OverlayTrigger} from 'react-bootstrap';
import moment from "moment/moment";

import Table, {tableTextFilter} from '../Table/Table';
import {DATE_LOCALE} from '../../Constants/constants';

export default function UsersTable(props) {
    const headerStyle = {fontSize: 14};
    const filtersRefs = useRef([]);

    const resetFilters = () => {
        filtersRefs.current.forEach(filter => {
            if (filter)
                filter('');
        })
    }

    const actionsFormatter = (cell, row) => {
        return (
            <DropdownButton title="Actions" variant="outline-secondary" size="sm">
                <Dropdown.Item as="button" eventKey={row.userKey}
                               onSelect={props.resetPassword}>Reset Password</Dropdown.Item>
                <Dropdown.Item as="button" eventKey={row.userKey}
                               onSelect={props.removeUser}>Remove User</Dropdown.Item>
                {/*<Dropdown.Item as="button" eventKey={row.userId}*/}
                {/*               onSelect={props.viewAsUser}>View As User</Dropdown.Item>*/}
            </DropdownButton>);
    }

    const dateTimeFormatter = (cell, row) => {
        return cell ? moment(cell).format('lll') : '';
    }

    const accountStatusFormatter = (cell, row) => {
        if (!cell) {
            return '';
        }
        if (cell === 'Active') {
            return 'Enabled';
        }
        return <Badge variant={'danger'}>Disabled</Badge>;
    }

    const confirmationStatusFormatter = (cell, row) => {
        if (!cell) {
            return '';
        }

        if (cell === 'Confirmed') {
            return cell;
        }
        const tooltip = row.confirmationStatusTooltip;

        return <OverlayTrigger
            overlay={
                <Tooltip>{tooltip}</Tooltip>
            }>
            <Badge variant={'warning'}>{cell}</Badge>
        </OverlayTrigger>

    }

    const userIdFormatter = (cell, row) => {
        if (row.viewAsUserId) {
            return <h5><Badge variant={'primary'}>{cell}</Badge></h5>
        }
        return cell;
    }

    const columns = [
        {dataField: 'userId', text: 'User ID', headerStyle: headerStyle, sort: true, filter: tableTextFilter(filtersRefs), formatter: userIdFormatter},
        {dataField: 'fullName', text: 'Full Name', headerStyle: headerStyle, sort: true, filter: tableTextFilter(filtersRefs), editable: false},
        {dataField: 'email', text: 'Email', headerStyle: headerStyle, sort: true, filter: tableTextFilter(filtersRefs), editable: false},
        {dataField: 'accountStatus', text: 'Account Status', headerStyle: headerStyle, sort: true, filter: tableTextFilter(filtersRefs), editable: false, formatter: accountStatusFormatter},
        {dataField: 'confirmationStatusText', text: 'Confirmation Status', headerStyle: headerStyle, sort: true, filter: tableTextFilter(filtersRefs), editable: false, formatter: confirmationStatusFormatter},
        {dataField: 'role', text: 'Role', headerStyle: headerStyle, sort: true, filter: tableTextFilter(filtersRefs), editable: false},
        {dataField: 'creationTime', text: 'Creation Time', headerStyle: headerStyle, sort: false, editable: false, formatter: dateTimeFormatter},
        {dataField: 'actions', text: '', sort: false, editable: false, formatter: actionsFormatter}
    ]

    return (
        <>
            {
                (!props || !props.data || props.data?.length === 0) &&
                <Spinner animation="border" variant="primary"/>
            }
            {
                props.data?.length > 0 &&
                <Table
                    keyField={'userKey'}
                    data={props.data}
                    columns={columns}
                    pageSize={10}
                    exportCsv={true}
                    addNewUser={props.addNewUser}
                    csvFileName={`Users_Report_${new Date().toLocaleString({locale: DATE_LOCALE})}.csv`}
                    resetFilters={resetFilters}
                    enableColumnHider={false}
                />
            }
        </>
    )
}